import { render, staticRenderFns } from "./searchDetailView.vue?vue&type=template&id=4a8b25d6&"
import script from "./searchDetailView.vue?vue&type=script&lang=js&"
export * from "./searchDetailView.vue?vue&type=script&lang=js&"
import style0 from "./searchDetailView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports